import visaIcon from "@/assets/visa.svg";
import mastercardIcon from "@/assets/mastercard.svg";
import amexIcon from "@/assets/amex.svg";
import googlePayIcon from "@/assets/google-pay.svg";
import applePayIcon from "@/assets/apple-pay.svg";
import { t } from "i18next";

export default function PaymentMethods() {
  return (
    <div className="rounded-lg bg-card p-4">
      <div className="flex flex-col space-y-3">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium">
              {t("securityHeader.acceptedPaymentMethods")}
            </span>
          </div>
          <div className="flex items-center gap-2 sm:gap-4 overflow-x-auto">
            <img src={visaIcon} alt="Visa" className="h-6 sm:h-8" />
            <img src={mastercardIcon} alt="Mastercard" className="h-6 sm:h-8" />
            <img src={amexIcon} alt="American Express" className="h-6 sm:h-8" />
            <img src={googlePayIcon} alt="Google Pay" className="h-6 sm:h-8" />
            <img src={applePayIcon} alt="Apple Pay" className="h-6 sm:h-8" />
          </div>
        </div>

        <div className="flex items-start gap-2">
          <div className="flex-1 justify-center">
            <p className="text-sm text-muted-foreground">
              {t("securityHeader.poweredByStripe")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
